/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.ImageUpload || (M.Template.ImageUpload = {});

M.Template.ImageUpload.EditableImageSimple = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   *
   * css embedded in template - tied closely to how elements overlay
   *   each other
   */
__p+='\n\n<div class="editableImageSimple">\n\n  ';
 if (!disableEdit) { 
__p+='\n  <div class="inputContainer">\n    <input type="file" name="imageFile" class="fileupload"/>\n  </div>\n  ';
 } 
__p+='\n\n  <div class="imageAssetContainer"\n      style="height:'+
((__t=( M.html.htmlAttributeEscape(displayHeight) ))==null?'':__t)+
'px;\n             width:'+
((__t=( M.html.htmlAttributeEscape(displayWidth) ))==null?'':__t)+
'px">\n    ';
 if (imgUrl) { 
__p+='\n      <img class="imageAsset"\n          style="height:'+
((__t=( M.html.htmlAttributeEscape(displayHeight) ))==null?'':__t)+
'px;\n                 width:'+
((__t=( M.html.htmlAttributeEscape(displayWidth) ))==null?'':__t)+
'px"\n          src="'+
((__t=( M.html.htmlAttributeEscape(imgUrl) ))==null?'':__t)+
'"/>\n    ';
 } else { 
__p+='\n      <img class="imageAsset"\n          style="height:'+
((__t=( M.html.htmlAttributeEscape(displayHeight) ))==null?'':__t)+
'px;\n                 width:'+
((__t=( M.html.htmlAttributeEscape(displayWidth) ))==null?'':__t)+
'px"/>\n    ';
 } 
__p+='\n  </div>\n\n  ';
 if (disableEdit && disabledEditExplanationText) { 
__p+='\n    <div class="disabledEditExplanationText tc" style="display:none;">\n      <p>'+
((__t=( M.html.htmlAttributeEscape(disabledEditExplanationText) ))==null?'':__t)+
'</p>\n    </div>\n  ';
 } 
__p+='\n\n\n  ';
 if (imgUrl) { 
__p+='\n    <div class="imagePromptTextBlock" style="display:none">\n  ';
 } else { 
__p+='\n    <div class="imagePromptTextBlock">\n  ';
 } 
__p+='\n      <div class="addImageText">\n        <span class="plusSign">+</span>\n        <h6 class="addText">add image</h6>\n        <span>\n          '+
((__t=( M.html.htmlAttributeEscape(imageWidth) ))==null?'':__t)+
' x\n          '+
((__t=( M.html.htmlAttributeEscape(imageHeight) ))==null?'':__t)+
' pixels\n        </span>\n      </div>\n    </div>\n\n  <div class="imageButtonContainer">\n    <div>\n      <a class="imageChangeButton button buttonFlat buttonMedium\n          buttonPrimary">\n        change\n      </a>\n    </div>\n    <div>\n      <a class="imageDeleteButton button buttonFlat buttonMedium\n          buttonPrimary">\n        delete\n      </a>\n    </div>\n  </div>\n\n  <div style="display:none;" class="deleteDialog">\n    <p>\n      Select a reason. This will send an email to the designer.\n    </p>\n    <p><b>\n      This cannot be undone.\n    </b></p>\n    <p class="deleteDialogWarning"></p>\n    <ul class="deleteDialogButtons">\n      <br />\n      <li>\n        <a class="button buttonFlat buttonPrimary deleteDialogButton"\n        data-reasonIndex="0">\n        Signature is a font</a>\n      </li><br />\n      <li>\n        <a class="button buttonFlat buttonPrimary deleteDialogButton"\n        data-reasonIndex="1">\n        Too pixelated</a>\n      </li><br />\n      <li>\n        <a class="button buttonFlat buttonPrimary deleteDialogButton"\n        data-reasonIndex="2">\n        Too complicated</a>\n      </li>\n    </ul>\n  </div>\n</div>\n';
}
return __p;
});


return {};

});
/* end templito generated file */
